import React from "react";
import { connect } from 'react-redux'
import { setStep } from '../../api/gui/actions'
import { getStepOrderReadable, getStepOrder } from "../../constants";
import { SvgArrowRight, SvgArrowLeft } from "../svg";
import { Link } from "react-router-dom";


class BreadCrumbs extends React.Component {

    constructor(props){
        super(props)

        this.goToStep = this.goToStep.bind(this);
    }

    goToStep(index){
        this.props.dispatch(setStep(index));
    }

    render() {
        let CORRECT_STEP_ORDER = getStepOrder(this.props.offers.offerQueryParameters);
        let CORRECT_STEP_ORDER_READABLE = getStepOrderReadable(this.props.offers.offerQueryParameters);
        let currentIndex = CORRECT_STEP_ORDER.indexOf(this.props.gui.currentStep)
        
        return (
            <>
                { currentIndex < (CORRECT_STEP_ORDER.length - 1) ?
                    <div className={`bread-crumbs-container row justify-content-center${currentIndex !== 0 ? ' xs-pt-50' : ''}`}>
                        <div className="col-12 col-sm-10 col-md-8">
                            { CORRECT_STEP_ORDER.map((val, idx) => {
                                if (idx < currentIndex) {
                                    return <span key={`${val}-${idx}`} className="bread-crumbs" onClick={() => this.goToStep(idx)}>
                                        { idx > 0 ? <SvgArrowRight/> : ''}
                                        <Link to={`/step/${idx}`} onClick={() => this.props.dispatch(setStep(CORRECT_STEP_ORDER[idx]))}>{CORRECT_STEP_ORDER_READABLE[idx]}</Link>
                                    </span>
                                } 
                                if (idx == currentIndex && idx > 0) {
                                    return <span key={`${val}-${idx}`} className="bread-crumbs"><SvgArrowRight/>{CORRECT_STEP_ORDER_READABLE[idx]}</span>
                                }
                            })} 
                        </div>
                    </div> 
                    :
                    <div className={`bread-crumbs-container row justify-content-center${currentIndex !== 0 ? ' xs-pt-50' : ''}`}>
                        <div className="col-12 col-sm-10 col-md-8">
                        {/* <Route exact path="/" render={() => { return <Redirect to="/step/0" /> }} /> */}
                        <span className="bread-crumbs">
                            <SvgArrowLeft/><a href="/">Aftur í uppflettingu</a>
                        </span>
                        </div>
                    </div> 
                }
            </>
        )
    }

}

BreadCrumbs.defaultProps = { }

function mapStateToProps(state) {

    var f = {
        offers: {},
        gui: {}
    }
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui

    return f;
}

export default connect(mapStateToProps)(BreadCrumbs);